<div [ngClass]="['label' , type]">
  {{text}}
</div>
